var React = require('react');

function Search (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M10.5 18C14.6421 18 18 14.6421 18 10.5C18 6.35786 14.6421 3 10.5 3C6.35786 3 3 6.35786 3 10.5C3 14.6421 6.35786 18 10.5 18Z","stroke":"#333333","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M20.9998 21.0008L15.7998 15.8008","stroke":"#333333","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

Search.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Search;

Search.default = Search;
